import React from "react";
// import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function SecretVideoPurchase({ isOpen, toggle }) {
  const navigate = useNavigate();
  return (
    <Modal
      show={isOpen}
      size="md"
      centered
      className="secret-strategy-popup text-translate-modal"
    >
      <Modal.Header className="d-flex">
        <Modal.Title className="text-translation popup_heading m-0">
          Secret Video
        </Modal.Title>

        <Button
          variant="link"
          className="modalClose-Btn p-0"
          onClick={toggle}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>       
      <Modal.Body className="text-center">
        {/* <div> <img src="" alt="some image" /></div> */}
        <p className="simple-text">
          Please subscribe to our <b>gold plan</b> to see explanation videos.
        </p>

        <button
          className="prev-next-btn"
          onClick={() => navigate("/admin/plans")}
        >
          BUY PLAN
        </button>

        {/* <button className="btn btn-link" >Skip</button> */}
      </Modal.Body>
    </Modal>
  );
}
